"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Creates a middleware interface for persistence handlers.
 *
 * @param {Function[]} handlers
 * @param {Object} services
 */
var createMiddleware = function createMiddleware(handlers, _ref) {
  var storage = _ref.storage;
  return function (store) {
    return function (next) {
      return function (action) {
        var beforeState = store.getState();
        next(action);
        var afterState = store.getState();

        handlers.forEach(function (handler) {
          return handler(storage, beforeState, afterState, action, store);
        });
      };
    };
  };
};

exports.default = createMiddleware;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/middleware/persistence.js
// module id = 1153
// module chunks = 0